import script from "./DeviceSamplesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceSamplesView.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceSamplesView.vue?vue&type=style&index=0&id=81f74712&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81f74712"]])

export default __exports__